const API_BASE = 'https://new.sbdemolition.online/api/overtime';

export const overtimeAPI = {
  list: async (userId) => {
    const res = await fetch(`${API_BASE}/list.php?userId=${encodeURIComponent(userId)}`, {
      credentials: 'include',
    });
    return res.json();
  },
  listAll: async (adminId) => {  // ← خد adminId كـ parameter
    const res = await fetch(`${API_BASE}/list-all.php?adminId=${encodeURIComponent(adminId)}`, {
      credentials: 'include',
    });
    return res.json();
  },
  create: async (payload) => {
    const res = await fetch(`${API_BASE}/create.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  updateStatus: async (payload) => {
    const res = await fetch(`${API_BASE}/update-status.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    return res.json();
  },
};
